import { KeepInTouchFields, KeepInTouchProps, SocialLink } from "./fields.definitions";
import { CheckboxField, LinkField, StringField } from "../../types/types";

export class KeepInTouchModel {
  private readonly fields: null | KeepInTouchFields;
  constructor(props: KeepInTouchProps) {
    this.fields = props.fields || null;
  }

  get title(): StringField {
    return this.fields?.Title ?? { value: "Keep in touch" };
  }

  get content(): StringField {
    return (
      this.fields?.Content ?? {
        value: `
          <p>Stay up to date with  news, updates, offers and more.</p>
          <p>By submitting your e-mail address, you are accepting the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy.</a></p>`,
      }
    );
  }

  get textboxPlaceholderText(): StringField {
    return this.fields?.["Textbox Placeholder Text"] ?? { value: "E-mail Address" };
  }

  get showForm(): CheckboxField {
    return this.fields?.["Show Form"] ?? { value: false };
  }

  get submitButtonLink(): LinkField | undefined {
    return this.fields?.["Submit Button Link"];
  }

  get socialMediaTitle(): StringField {
    return (
      this.fields?.["Social Media Title"] ?? { value: "Find us on social media" }
    );
  }

  get socialMediaLinks(): SocialLink[] {
    return (
      this.fields?.["Social Media Links"] ?? [
        {
          fields: {
            Link: { value: { href: "https://facebook.com" } },
            Icon: { value: "dcx-facebook-fill" },
          }
        },
        {
          fields: {
            Link: { value: { href: "https://linkedin.com" } },
            Icon: { value: "dcx-linkedin-fill" },
          }
        },
        {
          fields: {
            Link: { value: { href: "https://twitter.com" } },
            Icon: { value: "dcx-twitter-fill" },
          }
        },
        {
          fields: {
            Link: { value: { href: "https://youtube.com" } },
            Icon: { value:  "dcx-youtube-fill" },
          }
        },
      ]
    );
  }
}
